@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup()" [eventHelpText]="eventHelpText" />
}
<div
    #msOptionGroupRendererExportedDirective="msOptionGroupRendererExport"
    class="option-group-container"
    msOptionGroupRenderer
    [ngClass]="{ 'ht-of-single-row-options': msOptionGroupRendererExportedDirective.columnSettings.maxColumns === optionGroup().options.length }"
    [optionGroup]="optionGroup()"
    [optionPickClass]="'.option-pick > div'"
    (rerender)="rendererChange($event)">
    @for (option of optionGroup().options; track trackOption(i, option); let i = $index) {
        <ms-bet-builder-option
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [option]="option"
            [optionGroup]="optionGroup()"
            [sourceOfPick]="sourceOfPick"
            [event]="event"
            [class.option-hidden]="!showOption(i)"
            [showPromoBadge]="!!crmPromotedOptionIdsMap[option.id]" />
    }
</div>
@if (threshold()! < optionGroup().options.length) {
    <div class="show-more-less-button" [ngClass]="{ expanded: more() }" (click)="expand()">
        {{ more() ? sitecore.event.ShowLess : sitecore.event.ShowMore }} <span class="right-icon"><vn-icon name="theme-right" size="12" /></span>
    </div>
}
